import React from "react";

export default function ({ language, tools }) {
  class Tags extends React.Component {
    constructor() {
      super();
      this.state = {
        currentValue: "",
        config: {
          options: [],
        },
      };
    }

    componentDidMount() {
      const config = this.props.field.config;
      const globalState = this.props.globalState;
      this.setState({ config: config });
      this.setState({ currentValue: globalState[config.id] });
    }

    handleClick = (data) => {
      this.setState({ currentValue: data.value });
      this.props.field.state.value = data.value;
      this.props.onUpdate();
    };

    render() {
      return (
        <div>
          <div className="lz-input-wrapper">
            <label htmlFor={this.state.config.id}>
              {this.state.config.label}
            </label>
            <span className="lz-extratext"></span>
            <div className="lz-tag-wrap lz-input-error">
              {this.state.config.options.map((x, i) => (
                <Tag
                  data={x}
                  id={this.state.config.id}
                  currentValue={this.state.currentValue}
                  handleClick={this.handleClick}
                  key={i}
                />
              ))}
            </div>
            {this.props.errors}
          </div>
        </div>
      );
    }
  }

  return {
    html: Tags,
    validators: [
      (state) => {
        if (!state.value) return language.error_radio_button;
      },
    ],
    config: {},
  };
}

const Tag = ({ data, currentValue, handleClick, id }) => {
  return (
    <div className="lz-tag">
      <label htmlFor={id + data.value} onClick={() => handleClick(data)}>
        <input
          type="radio"
          // name={id}
          id={id + data.value}
          checked={data.value === currentValue}
          onChange={() => {}}
        />
        <div className="lz-tag-item">
          <div className="lz-tag-item--icon">
            <i className="fa fa-check"></i>
          </div>
          <div>
            <span>{data.display}</span>
          </div>
        </div>
      </label>
    </div>
  );
};
